import { Row, Col, Button } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { message, Select } from "antd";
import ChartDashboard from "./ChartDashboard";
import { payoutgenratedData } from "../PayoutManagement/helper/payoutdatasample";
import { useEffect, useState } from "react";
import { Dropdown, Menu, Form, Input } from "antd";
import {
  CheckCircleOutlined,
  DeleteOutlined,
  DownloadOutlined,
  EllipsisOutlined,
  PaperClipOutlined,
  QuestionCircleOutlined,
  TrophyTwoTone,
  UploadOutlined,
} from "@ant-design/icons";
import { Table } from "antd";
import "./PartnerDashboard.css";
import { Modal } from "antd";
import { render } from "@testing-library/react";
import { getMarginRight } from "react-table-sticky";
import AddInvoice from "./AddInvoice";
import AddPayout from "./AddPayout";
import { use } from "react";
import { fatechRemarkpratner, partnerPayoutListByFy } from "../../redux/PartnerPayoutListByFy/action";
import { connect } from "react-redux";
import { getInvoiceData, getInvoiceDownload, getInvoiceUploadAction, invoiceUploadDeleteAction, submitInvoicesForProccesing } from "../../redux/PayoutPartnerInvoiceUpload/Action";
import { Payout_Service } from "../../redux/Url";
import useSession from "../CustomLogout/useSession";
import { getRaisePayoutQueryInternalAction } from "../../redux/PayoutQueryInternal/Action";
import TextArea from "antd/lib/input/TextArea";
import { Tooltip } from "antd";
import moment from "moment";
import RemarksComponent from "./RemarksComponent";

const PayoutDashboardComponent = (props) => {
  const [form] = Form.useForm();
  const [dataSource, setDatasource] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [addInvoiceOpen, setAddInvoiceOpen] = useState(false);
  const [payoutAmountData, setPayoutAmountData] = useState([]);
  const [disbursementCountData, setDisbursementCountData] = useState([]);
  const [addPayoutOpen, setAddPayoutOpen] = useState(false);
  const [dataSource2, setDataSource2] = useState([]);
  const [currentReport, setCurrentReport] = useState(null);
  const [refreshCount, setRefreshCount] = useState(1);
  const [addQueryOpen, setAddQueryOpen] = useState(false);
  const [addResolveQueryOpen, setAddResolveQueryOpen] = useState(false);
  const [remarkComment, setRemarkComment] = useState("");
  const [monthlyReportId, setMonthlyReportId] = useState(null);
  const [submitting, setSubmitting] = useState(false);
  const [isloading, setIsLoading] = useState(false);
  const [remarks, setRemarks] = useState(false);
  const [resDataRM, setresDataRm] = useState([]);
  const [currentStage, setCurrentStage] = useState(null);
  const navigate = useNavigate();
  const handleSessionExpired = useSession();
  const getCurrentUserId =  props.userDetail?.userId;
  
  const getCurrentFinancialYear = () => {
    const today = new Date();
    const year = today.getFullYear();
    // Assuming FY starts in April
    return today.getMonth() >= 3
      ? { value: String(year), label: `${year}-${String(year + 1).slice(-2)}` }
      : {
        value: String(year - 1),
        label: `${year - 1}-${String(year).slice(-2)}`,
      };
  };

  // const partnerid = props.userDetail?.userId;
  const partnerid = props.partnerDetail?.partnerFirmId || props.partnerDetail?.partnerFirmId;
  // const partnerid = 2522;
 

  // Financial year state
  const [financialYear, setFinancialYear] = useState(
    getCurrentFinancialYear().value
  );

  const financialMonthOrderDesc = [
  // "Mar", "Feb", "Jan", "Dec", "Nov", "Oct", "Sep", "Aug", "Jul", "Jun", "May", "Apr"
    "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec", "Jan", "Feb", "Mar"
  
];

  const tableData = Array.isArray(dataSource)
    ? dataSource
    : dataSource?.content || [];

  const mappedTableData = tableData.map((item, index) => ({
    ...item,
    "GeneratedDate": item.createdAt
      ? new Date(item.createdAt).toISOString().slice(0, 10)
      : '',
  }));

  function getMonthAbbr(item) {
  // If fileName is like "Apr2024_report.csv"
  if (item.fileName) {
    return item.fileName.substring(0, 3);
  }
  // Fallback: try to use createdAt
  if (item.createdAt) {
    const date = new Date(item.createdAt);
    return date.toLocaleString('en-US', { month: 'short' });
  }
  return "";
}

// Sort mappedTableData by descending financial month order
const sortedTableData = [...mappedTableData].sort((a, b) => {
  const monthA = a.fileName.split('-')[0].toUpperCase();
  const monthB = b.fileName.split('-')[0].toUpperCase();
  
  const indexA = financialMonthOrderDesc.map(m => m.toUpperCase()).indexOf(monthA);
  const indexB = financialMonthOrderDesc.map(m => m.toUpperCase()).indexOf(monthB);
  return indexB - indexA; 
});


  const generateFinancialYearOptions = (startYear = 2022) => {
    const today = new Date();
    const year =
      today.getMonth() >= 3 ? today.getFullYear() : today.getFullYear() - 1;
    const options = [];
    for (let y = year; y >= startYear; y--) {
      options.push({
        value: String(y),
        label: `${y}-${String(y + 1).slice(-2)}`,
      });
    }
    return options;
  };

  useEffect(() => {
    // Fetch partner payout list by financial year when component mounts or financialYear changes
    fetchPartnerPayoutListByFy(financialYear, partnerid);
    
  }, [financialYear, partnerid, refreshCount]);

  const fetchPartnerPayoutListByFy = async (financialYear, partnerid) => {
    try {

      const partnerPayoutListData = props.partnerPayoutListByFy({
        accessToken: props.accessToken,
        partnerid: partnerid,
        // partnerid: "2522",
        financialYear: financialYear,
        approvalStageId: 4, // Assuming 4 is the approval stage ID you want to filter by partner
      });

      const partnerpayoutListResponse = await partnerPayoutListData;
      const errorCode = partnerpayoutListResponse?.response?.data?.error?.errorCode || partnerpayoutListResponse.errorCode;
      const errorMessage = partnerpayoutListResponse?.response?.data?.error?.errorMessage
      if (errorCode === "403" && (partnerpayoutListResponse?.response?.data?.error?.logoutStatus || partnerpayoutListResponse?.data?.error?.logoutStatus)) {
        
        handleSessionExpired();
        return;
      }
      
      let payoutAmountDataObject = [];
      let disbursementCountDataObject = [];
      partnerpayoutListResponse.map((item) => {
        const firstItem = item;
        setCurrentStage(firstItem.approvalStageId);
        
        payoutAmountDataObject.push({
          month: firstItem.fileName ? firstItem.fileName.substring(0, 3) : "",
          count:
            firstItem.netPayout !== undefined && firstItem.netPayout !== null
              ? String(firstItem.netPayout)
              : "",
        });
        disbursementCountDataObject.push({
          month: firstItem.fileName ? firstItem.fileName.substring(0, 3) : "",
          count:
            firstItem.totalDisbCount !== undefined &&
              firstItem.totalDisbCount !== null
              ? String(firstItem.totalDisbCount)
              : "",
        });
        setPayoutAmountData(payoutAmountDataObject);
        setDisbursementCountData(disbursementCountDataObject);
      });

    

      setDatasource(partnerpayoutListResponse);
    } catch (error) {
      console.error("Error fetching partner payout list by FY:", error);
    }
  };

  const fetchInvoicedata = async (reportdata) => {
    
    const invoicedata = await props.getInvoiceData({
      accessToken: props.accessToken,
      partnerId: reportdata.partnerId,
      reportId: reportdata.monthlyReportId || reportdata.reportId,
    })

    const errorCode = invoicedata?.response?.data?.error?.errorCode || invoicedata.errorCode;
    const errorMessage = invoicedata?.response?.data?.error?.errorMessage
    if (errorCode === "403" && (invoicedata?.response?.data?.error?.logoutStatus || invoicedata?.data?.error?.logoutStatus)) {
      console.error("Authentication failed. Please login again.");
      handleSessionExpired();
      return;
    }

    
    setDataSource2(invoicedata?.data?.invoiceDetails);
  }

  function getFileTypeFromPath(path) {
  if (!path) return '';
  const lastDot = path.lastIndexOf('.');
  if (lastDot === -1) return '';
  return path.substring(lastDot + 1).toLowerCase();
}

  const handlePayoutPath = async (data) => {
  try {
    // const response = await props.getInvoiceDownloadAction({
    //   accessToken: props.accessToken,
    //   filePath: data.invoicePath,
    // });

     const response = await fetch(
      `${Payout_Service}/reports/download/partnerDoc?path=${data.payoutPath}`,
      {
        method: 'GET',
        headers: {
          'Accept': 'application/json, text/plain, */*',
          'Authorization': `Bearer ${props.accessToken}`,
          // Add other headers if needed
        },
      }
    );

    if (!response.ok) {
      console.error('No PDF data received.');
      return;
    }

   const getFileExtension = (getFileTypeFromPath(data.payoutPath) || 'pdf');
    console.log("file type", getFileExtension);


  
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = data.fileName || `downloaded-file.${getFileExtension}`; // Set desired filename
    document.body.appendChild(a);
    a.click();
    a.remove();

    window.URL.revokeObjectURL(url);

    message.success('Download successful!');
  } catch (error) {
    message.error('Download failed. Please try again.');
    console.error('Download failed:', error);
  }
  // await downloadPdf(data);
};

const handleInvoicePath = async (data) => {
  try {
    // const response = await props.getInvoiceDownloadAction({
    //   accessToken: props.accessToken,
    //   filePath: data.invoicePath,
    // });

     const response = await fetch(
      `${Payout_Service}/reports/download/partnerDoc?path=${data.invoicePath}`,
      {
        method: 'GET',
        headers: {
          'Accept': 'application/json, text/plain, */*',
          'Authorization': `Bearer ${props.accessToken}`,
          // Add other headers if needed
        },
      }
    );

    if (!response.ok) {
      console.error('No PDF data received.');
      return;
    }

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.href = url;
    a.download = data.fileName || 'downloaded-file.pdf'; // Set desired filename
    document.body.appendChild(a);
    a.click();
    a.remove();

    window.URL.revokeObjectURL(url);

    message.success('Download successful!');
  } catch (error) {
    message.error('Download failed. Please try again.');
    console.error('Download failed:', error);
  }
  // await downloadPdf(data);
};

  const handleDeleteInvoice = async (record) => {
    
    try {
     const res = await props.RemoveInvoice({
      accessToken: props.accessToken,
      invoiceId: record.payoutReportInvoiceId,
      });
      const errorCode = res?.response?.data?.error?.errorCode || res.errorCode;
      const errorMessage = res?.response?.data?.error?.errorMessage
      if (errorCode === "403" && (res?.response?.data?.error?.logoutStatus || res?.data?.error?.logoutStatus)) {
        console.error("Authentication failed. Please login again.");
        handleSessionExpired();
        return;
      }
      
      if (res.status === 200) {
        message.success("Invoice deleted successfully");
        // Refresh the invoice data after deletion
        await fetchInvoicedata(currentReport);
      } else {
        message.error("Failed to delete invoice");
      }
    } catch (error) {
      console.error("Error deleting invoice:", error);
      message.error("Error deleting invoice: " + (error.message || "Unknown error"));
    }

  };

  const handleUploadInvoice = async (requestData) => {
    try {
      // Upload the invoice
      const uploadResult = await props.getInvoiceUploadAction({
        accessToken: props.accessToken,
        formData: requestData,
      });
      
      const errorCode = uploadResult?.data?.error?.errorCode || uploadResult.errorCode;
      const errorMessage = uploadResult?.data?.error?.errorMessage
      if (errorCode === "403" && (uploadResult?.data?.error?.logoutStatus || uploadResult?.data?.error?.logoutStatus)) {
        console.error("Authentication failed. Please login again.");
        handleSessionExpired();
        return;
      }

      const reportId = requestData.get('reportid');
      const partnerId = requestData.get('partnerid');
      if (!reportId || !partnerId) {
        throw new Error("Missing reportId or partnerId in requestData");
      }



      // Fetch updated invoice details
      const invoiceResponse = await props.getInvoiceData({
        accessToken: props.accessToken,
        partnerId,
        reportId,
      });

      const errorCode1 = invoiceResponse?.data?.error?.errorCode || invoiceResponse.errorCode;
      const errorMessage1 = invoiceResponse?.data?.error?.errorMessage
      if (errorCode === "403" && (invoiceResponse?.data?.error?.logoutStatus || invoiceResponse?.data?.error?.logoutStatus)) {
        console.error("Authentication failed. Please login again.");
        handleSessionExpired();
        return;
      }

      setDataSource2(invoiceResponse?.data?.invoiceDetails || []);
      return uploadResult;
    } catch (error) {
      console.error("Error uploading invoice:", error);
      // Optionally, show a user-friendly error message here
      return "Error uploading invoice";
    }
  };

  const getDownloadData = async (format, payoutgrp) => {
    
    try {
      const response = await fetch(
        // `http://localhost:8301/partner-payout-service/reports/download/partner?report_id=${ReportId}&approval_stage_id=${currentStage}&format=${format}`,
        // `${Payout_Service}/reports/download/partner?report_id=${payoutgrp}&approval_stage_id=4&format=${format}`,
        `${Payout_Service}/reports/payout-lan-report-export?lanTab=ALL&reportId=${payoutgrp.monthlyReportId}&partnerId=${payoutgrp.partnerId}&format=${format}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + props.accessToken, // Use the access token from props
          },
        }
      );

      if (!response.ok) throw new Error("Network response was not ok");

      const blob = await response.blob();
      const urlBlob = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = urlBlob;
      a.download = format === 'csv' ? 'report.csv' : 'report.xlsx';
      document.body.appendChild(a);
      a.click();
      a.remove();
      message.success('Successfully downloaded the report');
      window.URL.revokeObjectURL(urlBlob);
    } catch (error) {
      message.error("Error downloading data:", error);
      // Optionally, show a user-friendly error message here
    }
  };

  const handleInvoiceModal = () => {
    
    setAddInvoiceOpen(true);
  };

  const handlePayoutModal = () => {
    setAddPayoutOpen(true);
  };

  // const columnsData = [

  const baseColumns = [
    {
      title: "Invoice Number",
      dataIndex: "invoiceId",
      key: "invoiceId",
      align: "center",
      render:(record)=> {
        const invoiceNumber = record.split('_')[0] || ''
        return(
          <span>{invoiceNumber}</span>
        )
      }
    },
    {
      title: "Invoice Amount",
      dataIndex: "invoiceAmount",
      key: "invoiceAmount",
      align: "center",
      render: (amount) => amount?.toLocaleString("en-IN", { style: "currency", currency: "INR" }),
    },
    {
      title: "Invoice Date",
      dataIndex: "invoiceDate",
      key: "invoiceDate",
      align: "center",
       render: (date) => date ? moment(date).format("MMMM D, YYYY") : "-"
    },
    {
      title: "Invoice Report",
      dataIndex: "invoicePath",
      key: "invoicePath",
      align: "center",
      render: (_, partner) => {
        const fullFileName = partner.invoicePath?.split('/').pop() || '';
        const lastUnderscore = fullFileName.lastIndexOf('_');
        const fileName =
          lastUnderscore !== -1
            ? fullFileName.substring(0, lastUnderscore) + fullFileName.substring(fullFileName.lastIndexOf('.'))
            : fullFileName;
        return (
          <a type="link" style={{ color: "#1b8593", textDecoration: 'none', cursor: 'pointer' }} >
            <Button className="invoicePaperClip" onClick={() =>
              handleInvoicePath(partner)
            }>
              {/* <PaperClipOutlined /> */}<span style={{ color: "#1b8593", }}><u>{fileName}</u></span>
            </Button>
          </a>
        )
      },
    },
    {
      title: "Payout Report",
      dataIndex: "PayoutReport",
      key: "PayoutReport",
      align: "center",
      render: (_, partner) => {
        const fullFileName = partner.payoutPath?.split('/').pop() || '';
        const lastUnderscore = fullFileName.lastIndexOf('_');
        const fileName =
          lastUnderscore !== -1
            ? fullFileName.substring(0, lastUnderscore) + fullFileName.substring(fullFileName.lastIndexOf('.'))
            : fullFileName;

        return (
          <a type="link" style={{ color: "#1b8593", textDecoration: 'none', cursor: 'pointer' }} >
            <Button className="invoicePaperClip" onClick={() => handlePayoutPath(partner)}>
              {/* <PaperClipOutlined /> */}
              <span style={{ color: "#1b8593", }}><u>{fileName}</u></span>
            </Button>
          </a>
        )
      },
    },
    { title: "Remark", dataIndex: "Remark", key: "Remark", align: "center", 
      render: (_,record)=>{
        return(
          <span 
        style={{ fontSize: "14px", maxWidth: "200px", display: "inline-block" }} 
      > {record?.remarks?.remarksComment || ""}</span>
        )
      }

    , },
   
  ];

  const actionsColumn =  {
      title: "Action",
      dataIndex: "Action",
      key: "Action",
      align: "center",
      render: (_, record) => (
        <Button className="deleteRecord" onClick={() => handleDeleteInvoice(record)}>
          <DeleteOutlined />
        </Button>
      ),
    }

    const columnsData = currentReport?.approvalStageId < 6
  ? [...baseColumns, actionsColumn]
  : baseColumns;
  // invoice details table columns

  const headerMenu = (payoutgrp) => (
    <Menu
      onClick={({ key }) => handleHeaderMenuClick(key, payoutgrp)}
      items={[
        { label: "Export to CSV", key: "ExportCSV" },
        { label: "Export to Excel", key: "ExportExcel" },

        // { label: "Export Invoice Report", key: "InvoiceReport" },
      ]}
    />
  );

  const headerActionMenu = (record) => (
    <Menu
      onClick={({ key }) => handleQueryModal(key)}
      items={[
        // {
        //   label: "Raise Query",
        //   key: "RaiseQuery",
        // },

      ]}
    />
  );

  const handleQueryModal = (payoutgrp) => {
    setAddQueryOpen(true);
    setMonthlyReportId(payoutgrp.monthlyReportId);
  };

  const handleResolveModal = (payoutgrp) => {
    setAddResolveQueryOpen(true);
    setMonthlyReportId(payoutgrp.monthlyReportId);
  }

  const handleModalCancel = () => {
    setAddQueryOpen(false);
    setAddResolveQueryOpen(false);
    form.resetFields();
    setRemarkComment("");
  };

  const handleQueryRemark = async () => {
    
    setIsLoading(true)

    if(remarkComment.trim() === "") {

      message.error("Input remark is not valid.");
      form.resetFields();
      setRemarkComment("");
      return;
    }

    // const getpartnerIds = Object.keys(selectedCheckboxes.Check).length > 0 ? selectedCheckboxes.Check.map(item => item.partnerId) : [selectedPartnerId];

    const queryData = {
      "partnerid": [partnerid],
      "reportid": monthlyReportId,
      "userId": props.userDetail?.userId,
      "payoutid": [],
      "stage": 6, // Assuming stage 6 is for PartnerQuery
      "remarks": {
        "partnerId": partnerid,
        "reportId": monthlyReportId,
        "userId": props.userDetail?.userId,
        "remarksComment": remarkComment,
        "stage": 6, // Assuming stage 6 is for PartnerQuery
        "remarkType": "PartnerQuery"
      }
    };
    try {

      const resQuery = await props.RaiseQuery({
        accessToken: props.accessToken,
        query: queryData
      });
      await new Promise(resolve => setTimeout(resolve, 500)); // Wait for 500ms to ensure the message is displayed
      message.success("Query raised successfully"); 
      
      form.resetFields();
      setRemarkComment('');
      setAddQueryOpen(false);
      await fetchPartnerPayoutListByFy(financialYear, partnerid);

    } catch (error) {
      console.error("Error in handleQueryRemark:", error);
      return "Error while RaiseQuery" + error.message || "Error while RaiseQuery";
    } finally {
      setIsLoading(false);
    }
  }


    const handleResolveQueryRemark = async () => {
    
    setIsLoading(true)

    if(remarkComment.trim() === "") {

      message.error("Input remark is not valid.");
      form.resetFields();
      setRemarkComment("");
      return;
    }

    // const getpartnerIds = Object.keys(selectedCheckboxes.Check).length > 0 ? selectedCheckboxes.Check.map(item => item.partnerId) : [selectedPartnerId];

    const queryData = {
      "partnerid": [partnerid],
      "reportid": monthlyReportId,
      "userId": props.userDetail?.userId,
      "payoutid": [],
      "stage": 7, // Assuming stage 7 is for Submitting Query Resolution
      "remarks": {
        "partnerId": partnerid,
        "reportId": monthlyReportId,
        "userId": props.userDetail?.userId,
        "remarksComment": remarkComment,
        "stage": 7, // Assuming stage 7 is for submitting query resolution
        "remarkType": "PartnerQuery"
      }
    };
    try {

      const resQuery = await props.RaiseQuery({
        accessToken: props.accessToken,
        query: queryData
      });
      await new Promise(resolve => setTimeout(resolve, 500)); // Wait for 500ms to ensure the message is displayed
      message.success("Query Resolve successfully"); 
     
      form.resetFields();
      setRemarkComment('');
      setAddQueryOpen(false);
      setAddResolveQueryOpen(false);
      await fetchPartnerPayoutListByFy(financialYear, partnerid);

    } catch (error) {
      console.error("Error in handleQueryRemark:", error);
      return "Error while RaiseQuery" + error.message || "Error while RaiseQuery";
    } finally {
      setIsLoading(false);
    }
  }

  const handleChange = (event) => {
    // setAddRemarks(event.target.value);
    const value = event.target.value;
    
    // const words = value.trim().split(/\s+/);
    if (value.length <= 250) {
     
      setRemarkComment(value);
      // setApproveRemarks(value);
    } else {
     
      // setAddRemarks(value.slice(0, 250).join(' '));
      message.error("You can only enter a maximum of 250 characters.");
      form.resetFields();
      setRemarkComment("");
    }
  }


  const handleHeaderMenuClick = async (key, record) => {
   
    switch (key) {
      case "ExportCSV":


       
        await getDownloadData("csv", record);
        break;
      case "ExportExcel":
        
        await getDownloadData("excel", record);
        break;
      case "InvoiceReport":
       
        break;
      default:
        
    }
  };
  const handleModal = async (payoutgrp) => {
    
    const rest = await fetchInvoicedata(payoutgrp);
    const reprtdata = {
      reportId: payoutgrp.monthlyReportId,
      partnerId: payoutgrp.partnerId,
      approvalStageId: payoutgrp.approvalStageId
    }
    setCurrentReport(reprtdata);
   


    setIsModalOpen(true);

  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setAddInvoiceOpen(false);
  };

  const handleInvoiceCancel = () => {
    setAddInvoiceOpen(false);
  };

   const formatRemarks = (remarks) => {
    
    const sortdata = remarks.sort((a, b) => {
    const dateA = new Date(a.createDateTime);
    const dateB = new Date(b.createDateTime);
    
   
    
    return  dateA.getTime()- dateB.getTime(); // Newest first
    });
    

    return remarks
      ?.sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate))
      .map((remarks) => (
        <div className='containerRemarks' style={{ display: 'block' }} key={remarks.lanRemarkId}>
          <div style={{ display: 'flex' }}>
            <b>{remarks.userName}</b>
            <b className='userRole' >({remarks.userRole})</b>
          </div>
          <div style={{ display: 'grid' }} className='commentContainer'>
            <span style={{ maxWidth:"200px"}}> {remarks.remarksComment} </span>
            <small>
              {new Date(remarks.createDateTime).toLocaleString()}
              {/* | Reason:{remarks.lanRemarkType} */}
            </small>
          </div>
        </div>
      ));
  };

    const handleRemarksModal = async (record,key) => {
     
      // setIsLoading(key);

     const remarkdata = {
        reportId: record.monthlyReportId,
        partnerId: record.partnerId,
         remarkTypes: [
        "PartnerQuery",
        // "PartnerInvoice"
    ]
  }

      const resData1 = await props.fatechRemarpratner({
        accessToken: props.accessToken,
        remarkdata: remarkdata
      });
  
      const errorCode = resData1?.response?.data?.error?.errorCode || resData1.errorCode;
      const errorMessage = resData1?.response?.data?.error?.errorMessage
      if (errorCode === "403" && (resData1?.response?.data?.error?.logoutStatus || resData1?.data?.error?.logoutStatus)) {
        console.error("Authentication failed. Please login again.");
        handleSessionExpired();
        return;
      }
      // setIsLoading(null);
      
  
      const flatArray = Object.values(resData1).flat();
     

      const data = flatArray.filter((item) => ["PAYOUT MAKER", "Partner"].includes(item.userRole));
      
  
      const resData = formatRemarks(data);
  
      setresDataRm(resData);
      if(resData.length > 0){
      setRemarks(true)
      }else{
        // setIsLoading(null);
        message.warning("No remarks found for this record.");
  
      }
  
    }

  const handelsubmitInvoceProcessing = async () => {
    setSubmitting(true);
    try {

      const res = await props.submitInvoices({
        accessToken: props.accessToken,
        partner_id: currentReport.partnerId,
        report_id: currentReport.reportId,
      });

      if (res && res.status === 401) {
        console.error("Authentication failed. Please login again.");

        return;
      }

      if (!res || res.error) {
        console.error("API Error:", res.error || "Unknown error");
        return;
      }

      
      message.info("Invoice submitted successfully");
      await fetchInvoicedata(currentReport);
      // Before setting state
     
      setIsModalOpen(false);
      setRefreshCount(prevRefreshCount => {
        const newCount = prevRefreshCount + 1;
        
        return newCount;
      });


    } catch (error) {
      console.error("Network or unexpected error:", error.message || error);
    } finally{
      setSubmitting(false);
      // form.resetFields();
      // setRemarkComment("");
    }
  };

  const handelnavtolandata = (partner) => {
    navigate(`Details/${partner.monthlyReportId}`, {
      state: {
        partnerId: partner.partnerId,
        fileName: partner.fileName,
      }
    });

  }

  const columns = [
    
    {
      title: "File Name",
      dataIndex: "fileName",
      key: "fileName",
      render: (_, payoutgrp) => (
       
        <p onClick={() => { handelnavtolandata(payoutgrp) }} style={{ color: "#1b8593", textDecoration: 'none' }}>
          {payoutgrp.fileName}
        </p>
      ),
      align: "center",
      fixed: "left",
    },
    
    {
      title: "Records in File",
      dataIndex: "totalDisbCount",
      key: "totalDisbCount",
      align: "center",
    },
    {
      title: "Total Disb. Amount",
      dataIndex: "totalDisbAmount",
      key: "totalDisbAmount",
      align: "center",
      render: (amount) => amount?.toLocaleString("en-IN", { style: "currency", currency: "INR" }),
    },
    {
      title: "Gross Payout",
      dataIndex: "grossPayout",
      key: "grossPayout",
      align: "center",
      render: (amount) => amount?.toLocaleString("en-IN", { style: "currency", currency: "INR" }),
    },
    {
      title: "Payout on Hold",
      dataIndex: "payoutOnHold",
      key: "payoutOnHold",
      align: "center",
      render: (amount) => amount?.toLocaleString("en-IN", { style: "currency", currency: "INR" }),
    },
    {
      title: "Recovery Amount",
      dataIndex: "recoveryAmount",
      key: "recoveryAmount",
      align: "center",
      render: (amount) => amount?.toLocaleString("en-IN", { style: "currency", currency: "INR" }),
    },
    {
      title: "Retro Adj.",
      dataIndex: "retroAdjustment",
      key: "retroAdjustment",
      align: "center",
      render: (amount) => amount?.toLocaleString("en-IN", { style: "currency", currency: "INR" }),
    },
    {
      title: "Net Payout",
      dataIndex: "netPayout",
      key: "netPayout",
      align: "center",
      render: (amount) => amount?.toLocaleString("en-IN", { style: "currency", currency: "INR" }),
    },
   
    {
      title: "Payout status",
      dataIndex: "payoutStatus",
      key: "payoutStatus",
      align: "center",
    },
    {
      title: "Remarks",
      dataIndex: "remarks",
      key: "remarks",
      align: "center",
       render: (_, record,key) => (
              <Button  className='remarkView-btn' style={{ background:"#fff", border: "none", color: "#000", fontSize: "14px" }} onClick={() => handleRemarksModal(record,key)} >
                Remark
              </Button>
            )
    },
    
    {
      title: (_, record) => (
        <Dropdown overlay={headerActionMenu(record)} trigger={['click']}>
          <span style={{ cursor: 'pointer' }}>
            Action 
          </span>
        </Dropdown>
      ),
      dataIndex: "operations",
      key: "operations",
      align: "center",
      fixed: 'right',
      render: (_, payoutgrp) => (
        <div className="action-container">
          <Dropdown overlay={headerMenu(payoutgrp)} trigger={["click"]} >
             <Tooltip title="Download Report">
            <span style={{ cursor: "pointer" }}>
              <DownloadOutlined />
            </span>
            </Tooltip>
          </Dropdown>
          <Button onClick={() => handleModal(payoutgrp)}>
             <Tooltip title="Upload Invoice">
            <UploadOutlined />
            </Tooltip>
          </Button>
          {payoutgrp.approvalStageId >= 7 ? [] : (<><Button onClick={() => handleQueryModal(payoutgrp)}>
             <Tooltip title="Raise Query">
            <QuestionCircleOutlined />
            </Tooltip>
          </Button>
         
          </>)
          }

           {payoutgrp.invoiceSubmitted == true && payoutgrp.approvalStageId == 5 &&(<Button onClick={() => handleResolveModal(payoutgrp)}>
              <Tooltip title="Resolve Query">
            <CheckCircleOutlined />
            </Tooltip>
          </Button>)}
        </div>
      ),
    },
  ];

  return (
    <div className="partner-payout-dashboard" style={{ maxWidth: "100%" }}>
      <Row>
        <div style={{ display: "flex" }}>
          <Col lg={12} xs={12} md={12} sm={12}>
            <Col
              md={6}
              style={{ display: "flex", marginTop: 10 }}
              className="btn-partner-files"
            >
              <div>
                <Select
                  style={{ width: 150, marginTop: 10 }}
                  showSearch
                  placeholder="Select financial Year"
                  optionFilterProp="label"
                  value={financialYear}
                  onChange={(value) => {
                    setFinancialYear(value);
                    setPayoutAmountData([]);
                    setDisbursementCountData([]);
                  }}
                  options={generateFinancialYearOptions(2022)}
                />
              </div>
            </Col>
          </Col>
        </div>
      </Row>
      <Row>
        <Col lg={12} xs={12} md={12} sm={12}>
          {payoutAmountData.length > 0 && disbursementCountData.length > 0 && (
            <ChartDashboard
              payoutAmountData={payoutAmountData}
              disbursementCountData={disbursementCountData}
            />
          )}
        </Col>
      </Row>
      <Row>
        <Col lg={12} xs={12} md={12} sm={12}>
          <Table
            className="partnerMonth"
            scroll={{ x: "max-content" }}
            style={{ marginTop: 20, alignItems: "center" }}
            columns={columns}
            dataSource={sortedTableData}
          />
        </Col>
      </Row>
      <AddInvoice
        addInvoiceOpen={addInvoiceOpen}
        setAddInvoiceOpen={setAddInvoiceOpen}
        dataSource2={dataSource2}
        setDataSource2={setDataSource2}
        handleUploadInvoice={handleUploadInvoice}
        currentReport={currentReport}
        getCurrentUserId={getCurrentUserId}
      />
      <AddPayout
        addPayoutOpen={addPayoutOpen}
        setAddPayoutOpen={setAddPayoutOpen}
        dataSource2={dataSource2}
        setDataSource2={setDataSource2}
      />
      <RemarksComponent
        resData={resDataRM}
        remarks={remarks}
        setRemarks={setRemarks}
        isHistory={true}
      />

      <Modal
        open={isModalOpen}
        width={850}
        maskStyle={{ backgroundColor: "rgba(0, 0, 0, 0.2)" }}
        footer={[]}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <Table
          dataSource={dataSource2}
          style={{ marginTop: "20px", maxHeight: "60vh", overflow: "auto" }}
          columns={columnsData}
          pagination={false}
          scroll={{ x: "max-content" }}
        />
        {(currentReport?.approvalStageId < 6) && (
          <div className="button-container">
            <Button
              className="buttonInvoice"
              onClick={handleInvoiceModal}
            >
              Add Invoice
            </Button>
            <Button
              className="buttonSubmit"
              onClick={() => handelsubmitInvoceProcessing(currentReport)}
              disabled={dataSource2?.length < 1}
              loading={submitting}
            >
              Submit
            </Button>
          </div>
        )}
      </Modal>
      <Modal open={addQueryOpen} maskStyle={{ backgroundColor: 'rgba(0, 0, 0, 0.2)' }} footer={[]} onCancel={handleModalCancel}>
        <Form
          form={form}
          onFinish={({ QueryRemark }) => {
            setRemarkComment(QueryRemark);
            handleQueryRemark();
          }}
        >
          <Form.Item
            name="QueryRemark"
            label="Remark"
            required
            rules={[{ required: true, message: 'Please add Query Remark' },
            {
              validator: (_, value) => {
                if (value && value.split(/\s+/).filter(Boolean).length > 250) {
                  return Promise.reject('Remark cannot exceed 250 words');
                }
                return Promise.resolve();
              }
            }]}
            style={{ marginBottom: 0 }}
          >
            <TextArea
              // style={{ marginTop: 20 }}
              placeholder='Please add Query Remark'
              autoSize={{ minRows: 3, maxRows: 5 }}
              onChange={handleChange}  // Add this line to handle input changes
              value={remarkComment}  // Bind the value to the state
              maxLength={250}
              showCount={true}
            />
          </Form.Item>
          <button className='btn-query' loading={isloading}  disabled={isloading}  style={{ cursor: 'pointer', maxWidth: '250px', height: '40px', backgroundColor: '#1b8593', color: 'white' }}
          // htmlType="submit" 
          // type="primary"
          >
            Submit Query
          </button>
        </Form>
      </Modal>

        <Modal open={addResolveQueryOpen} maskStyle={{ backgroundColor: 'rgba(0, 0, 0, 0.2)' }} footer={[]} onCancel={handleModalCancel}>
        <Form
          form={form}
          onFinish={({ QueryRemark }) => {
            setRemarkComment(QueryRemark);
            handleResolveQueryRemark();
          }}
        >
          <Form.Item
            name="ResolveQueryRemark"
            label="Remark"
            required
            rules={[{ required: true, message: 'Please add your Remark' },
            {
              validator: (_, value) => {
                if (value && value.split(/\s+/).filter(Boolean).length > 250) {
                  return Promise.reject('Remark cannot exceed 250 words');
                }
                return Promise.resolve();
              }
            }]}
            style={{ marginBottom: 0 }}
          >
            <TextArea
              // style={{ marginTop: 20 }}
              placeholder='Please add your Remark'
              autoSize={{ minRows: 3, maxRows: 5 }}
              onChange={handleChange}  // Add this line to handle input changes
              value={remarkComment}  // Bind the value to the state
              maxLength={250}
              showCount={true}
            />
          </Form.Item>
          <button className='btn-query' loading={isloading}  disabled={isloading}  style={{ cursor: 'pointer', maxWidth: '250px', height: '40px', backgroundColor: '#1b8593', color: 'white' }}
          // htmlType="submit" 
          // type="primary"
          >
            Submit Remark
          </button>
        </Form>
      </Modal>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    partnerPayoutListByFy: (props) => dispatch(partnerPayoutListByFy(props)),
    getInvoiceUploadAction: (data) => dispatch(getInvoiceUploadAction(data)),
    submitInvoices: (data) => dispatch(submitInvoicesForProccesing(data)),
    getInvoiceData: (data) => dispatch(getInvoiceData(data)),
    getInvoiceDownloadAction: (data) => dispatch(getInvoiceDownload(data)),
    RaiseQuery: (data) => dispatch(getRaisePayoutQueryInternalAction(data)),
    RemoveInvoice: (data) => dispatch(invoiceUploadDeleteAction(data)),
    fatechRemarpratner: (data) => dispatch(fatechRemarkpratner(data)),
  };
};

const mapStateToProps = (state) => {
  return {
    accessToken: state && state.auth && state.auth.idToken,
    partnerPayoutListByFy: state.partnerPayoutListByFy.partnerPayoutListByFy,
    userDetail: state.auth?.userData,
    partnerDetail: state.auth?.partnerFirmDetails,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PayoutDashboardComponent);
